import { z } from "zod";

//User sign up schema
export const userSignUpSchema = z.object({
  username: z.string().min(5, "Username must be at least 5 characters!"),
  stageName: z.string().min(5, "Stage name must be at least 5 characters!"),
  email: z.string().email("Invalid email address!"),
  fullName: z.object({
    fName: z.string().min(2, "First name must be at least 2 characters!"),
    lName: z.string().min(2, "Last name must be at least 2 characters!"),
  }),
  password: z.string().min(6, "Minimum of 6 characters allowed!"),
  comfirmPassword: z.string(), 
})
.refine((data)=>data.password===data.comfirmPassword, {
  message: "Passwords do not match", path:["comfirmPassword"]
});

const gender=z.enum(["Male", "Female"])
//User Update Schema
export const userUpdateSchema = z.object({
  username: z.string().min(5, "Username must be at least 5 characters!"),
  stageName: z.string().min(5, "Stage name must be at least 5 characters!"),
  bio: z.string().optional(),
  fullName: z.object({
    fName: z.string().min(2, "First name must be at least 2 characters!"),
    lName: z.string().min(2, "Last name must be at least 2 characters!"),
  }),
  address: z.object({
    street: z.string().optional(),
    city: z.string().optional(),
    state: z.string().optional(),
    postalCode: z.string().optional(),
    country: z.string().optional(),
  }),
  phone: z.string().optional(),
  image: z.any().optional(),
  gender:z.string().refine((val)=>gender.options.includes(val), {message:"Please select your gender!"}),
  dob: z.string().optional(),
  socialHandles: z.object({
    facebook: z.string().optional(),
    x: z.string().optional(),
    spotify: z.string().optional(),
    boomplay: z.string().optional(),
    youtube: z.string().optional(),
    instagram: z.string().optional(),
    appleMusic: z.string().optional(),
  })
})
